export default "__VITE_ASSET__D2oJ3RDo__"